import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Heading,
  Stack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { SERVER_CONFIG_LIST } from "../constants";

type configObjectType = Record<string, string | number>;

type ConfigTableProps = {
  data: {
    cpu: configObjectType;
    memory: configObjectType;
    disk: configObjectType;
  };
};

const ConfigTable = ({ data }: ConfigTableProps) => {
  const { cpu, memory, disk } = data;
  return (
    <TableContainer>
      <Table
        size={{ base: "sm", sm: "md", md: "lg" }}
        overflowX={"auto"}
        variant={"striped"}
      >
        <Thead>
          <Tr>
            <Th>Unit</Th>
            <Th>GITLAB</Th>
            <Th>AAP</Th>
            <Th>Run Deck</Th>
            <Th>JumpBox</Th>
            <Th>Network Emulator</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>CPU</Td>
            <Td>{cpu.gitlab}</Td>
            <Td>{cpu.aap}</Td>
            <Td>{cpu.runDeck}</Td>
            <Td>{cpu.jumpBox}</Td>
            <Td>{cpu.networkEmulator}</Td>
          </Tr>
          <Tr>
            <Td>Memory</Td>
            <Td>{memory.gitlab}</Td>
            <Td>{memory.aap}</Td>
            <Td>{memory.runDeck}</Td>
            <Td>{memory.jumpBox}</Td>
            <Td>{memory.networkEmulator}</Td>
          </Tr>
          <Tr>
            <Td>Disk</Td>
            <Td>{disk.gitlab}</Td>
            <Td>{disk.aap}</Td>
            <Td>{disk.runDeck}</Td>
            <Td>{disk.jumpBox}</Td>
            <Td>{disk.networkEmulator}</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};

const ServerConfig = () => {
  return (
    <Box width="full">
      <Accordion allowToggle>
        {SERVER_CONFIG_LIST.map((config, index) => {
          const { title, content, data } = config;
          return (
            <AccordionItem key={index} marginBottom={1} role="group">
              <AccordionButton
                backgroundColor={"blackAlpha.100"}
                justifyContent={"space-between"}
              >
                <Heading
                  as={"h3"}
                  color="black"
                  textAlign="left"
                  fontSize={"md"}
                  _groupHover={{ color: "brand.100" }}
                >
                  {title}
                </Heading>
                <AccordionIcon color="brand.300" fontSize={"1.5rem"} />
              </AccordionButton>
              <AccordionPanel>
                <Stack my={4} spacing={6}>
                  <Text>{content}</Text>
                  <ConfigTable data={data} />
                </Stack>
              </AccordionPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </Box>
  );
};

export default ServerConfig;
